import type { ordersFr } from '../fr/ordersFr'

export const ordersEn: typeof ordersFr = {
    title: 'Orders',
    list: 'Order list',
    detail: 'Order detail',
    create: 'Create order',
    delete: 'Delete order',
    deleteConfirm: 'Are you sure you want to delete this order?',
    changeState: 'Change state',
    columns: {
        orderId: 'Order ID',
        name: 'Name',
        state: 'State',
        customer: 'Customer',
        requestedDeliveryDate: 'Requested delivery date',
        createdAt: 'Created at',
        error: 'Error',
        actions: 'Actions'
    },
    filters: {
        createdFrom: 'Created from',
        createdTo: 'Created until'
    },
    orderErrors: {
        filter: 'Orders in error',
        filterAll: 'All',
        filterOnly: 'In error only',
        title: 'This order cannot be completed',
        none: '—',
        tag: 'In error',
        boundary:
            'The {field} value of line {item} ({current}) falls outside the product encoding bounds ({min}–{max}).',
        boundaryShort: 'Out of bounds',
        product: 'Product {productId} of order {orderRef} has been deleted.',
        productUnidentified: 'The product of this line has been deleted.',
        productShort: 'Deleted product',
        unknown:
            'This order carries an error this dashboard cannot interpret ("{type}"). Update the dashboard.',
        unknownShort: 'Unknown error',
        goToProduct: 'Open the product page',
        goToItem: 'View the order line',
        deletedProduct:
            'This product is deleted. Restoring it will unblock the orders referencing it.'
    },
    model: {
        name: 'Order name',
        customer: 'Customer',
        address: 'Address',
        comments: 'Comments',
        product: 'Product',
        packaging: 'Packaging',
        first_bib: 'First bib',
        last_bib: 'Last bib',
        csv: 'CSV file',
        state: 'State',
        requestedDeliveryDate: 'Requested delivery date',
        eventDate: 'Event date'
    },
    states: {
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        cancelled: 'Cancelled',
        replaced: 'Replaced'
    },
    table: {
        actions: {
            deleteTitle: 'Delete order {name}',
            deleteContent: 'Are you sure you want to delete order {name} ? This action is final.'
        },
        title: 'Order items',
        addItem: 'Add item',
        removeItem: 'Remove item',
        productName: 'Product',
        quantity: 'Quantity',
        state: 'State',
        packaging: 'Packaging',
        comments: 'Comments',
        csvFile: 'CSV file',
        downloadCsv: 'Download CSV',
        logoFile: 'Logo',
        csvPlaceholder: 'Select a CSV file (.csv)',
        logoPlaceholder: 'Select a logo (.png, .jpg)',
        useCsv: 'Use CSV file',
        firstBib: 'First bib',
        lastBib: 'Last bib',
        text1: 'Text 1',
        text2: 'Text 2',
        text3: 'Text 3',
        noItems: 'No order items',
        itemNumber: 'Item {n}'
    },
    batches: {
        title: 'Batches',
        state: 'State',
        first: 'First',
        last: 'Last',
        size: 'Size',
        reprint: 'Reprint of Argos errors ({count} tags)',
        reprintOf: 'Reprint of batch {batch} ({count} tags)'
    },
    errors: {
        fetchFailed: 'Failed to load orders',
        createFailed: 'Failed to create order',
        createItemFailed: 'Failed to create order item {n}',
        deleteFailed: 'Failed to delete order',
        stateChangeFailed: 'Failed to change order state'
    },
    success: {
        created: 'Order created successfully',
        deleted: 'Order deleted successfully',
        stateChanged: 'Order state updated successfully'
    }
}
